"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudioInputFailed = AudioInputFailed;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _ModalTypes = require("@studio/constants/ModalTypes");
var _Refresh = require("../../../components/Modals/Refresh/Refresh");
function AudioInputFailed() {
  var isOpen = (0, _reactRedux.useSelector)(function (state) {
    var _state$modal;
    return ((_state$modal = state.modal) === null || _state$modal === void 0 ? void 0 : _state$modal.type) === _ModalTypes.AUDIO_INPUT_FAILED;
  });
  var title = 'Unable to Join Session';
  var content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "Your microphone is currently inaccessible. Make sure one is connected and not in use by another application."), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("em", null, "Refresh your browser to try again.")));
  return /*#__PURE__*/_react["default"].createElement(_Refresh.RefreshModal, {
    isOpen: isOpen,
    title: title
  }, content);
}